<template>
  <div class="data-grid-drawer"
       v-if="initialized">
    <transition name="el-fade-in">
      <div ref="drawerModal" class="drawer-modal" v-show="rendered" @click.self="hideDrawer"></div>
    </transition>
    <transition name="animation-slide-left"
                @after-enter="openedEvent"
                @after-leave="closedEvent">
      <div ref="drawerContent" class="drawer-content" :style="offsetStyle" v-show="rendered" @click.self="hideDrawer">
        <div class="slot-content">
          <slot></slot>
        </div>
        <div class="drawer-menu">
          <el-button type="text" @click="hideDrawer">
            <i class="el-icon el-icon-close"></i>
          </el-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import PopupManager from 'element-ui/lib/utils/popup/popup-manager'
import PopperBus from '../../../mixins/popper/bus'
import PopperDecorator from '../../../mixins/popper/decorator'
let drawerStore = {
  count: 0
}

export default {
  name: 'DataGridDrawer',
  mixins: [PopperBus, PopperDecorator],
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  provide () {
    return {
      $popper: this
    }
  },
  data () {
    return {
      initialized: false,
      rendered: false,
      drawerStore: drawerStore,
      drawerIndex: drawerStore.count
    }
  },
  computed: {
    offsetStyle: function () {
      let offset = this.drawerStore.count - this.drawerIndex - 1
      return offset > 0 ? {'transform': `translateX(${-offset * 100}px)`, '-webkit-transform': `translateX(${-offset * 100}px)`} : null
    }
  },
  methods: {
    showDrawer () {
      this.$emit('update:visible', true)
    },
    hideDrawer () {
      this.$emit('update:visible', false)
    },
    toggleDrawer () {
      this.$emit('update:visible', !this.visible)
    },
    initialDrawer () {
      if (!this.initialized) {
        this.initialized = true
        this.$nextTick(() => {
          if (this.$el) {
            document.body.appendChild(this.$el)
          }
          this.rendered = true
        })
      }
    }
  },
  mounted () {
    if (this.visible) {
      this.initialDrawer()
    }
  },
  destroyed () {
    drawerStore.count = this.drawerIndex
    if (this.$el) {
      let parentNode = this.$el.parentNode
      if (parentNode) {
        parentNode.removeChild(this.$el)
      }
    }
  },
  watch: {
    visible: function (val) {
      if (val && !this.initialized) {
        this.initialDrawer()
      } else {
        this.rendered = val
      }
      val ? this.openEvent() : this.closeEvent()
    },
    rendered: function (val) {
      if (val) {
        drawerStore.count++
        let drawerModal = this.$refs['drawerModal']
        if (drawerModal) {
          drawerModal.style.zIndex = PopupManager.nextZIndex()
        }
        let drawerContent = this.$refs['drawerContent']
        if (drawerContent) {
          drawerContent.style.zIndex = PopupManager.nextZIndex()
        }
      } else {
        drawerStore.count--
      }
    }
  }
}
</script>

<style lang="scss">
  .data-grid-drawer {
    & > .drawer-modal {
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0,0,0,.5);
    }
    & > .drawer-content {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      padding-left: 35px;
      max-width: 100%;
      box-sizing: border-box;
      transition: all .3s;
      & > .slot-content {
        min-width: 300px;
        height: 100%;
        color: #303133;
        background-color: #f0f2f5;
        box-shadow: -2px 0 8px rgba(0,0,0,.15);
      }
      & > .drawer-menu {
        position: absolute;
        left: 5px;
        top: 50%;
        width: 30px;
        height: 36px;
        line-height: 36px;
        margin-top: -18px;
        background-color: #fff;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        box-shadow: -5px 0 5px rgba(0,0,0,.1);
        .el-button {
          width: 100%;
          height: 100%;
          font-size: 16px;
          text-align: center;
          color: #606266;
          padding: 0 0 0 2px;
          border: none;
          outline: 0;
          box-sizing: border-box;
          &:hover {
            color: #303133;
          }
        }
      }
    }
  }
</style>
